export default {
  path: "*",
  name: "Error423",
  component: () => import("@/views/ErrorPages/Error423"),
  meta: {
    middleware_excemption: true
  }
};
